export default __webpack_public_path__ + "static/xsearch-b7cad96154ae1f00fd321fc814357bdb.png";